/* talk·point — Dark/Light Toggle (Web Component)
   Flippt data-tptheme am <html>, persistiert in localStorage, tauscht das Icon.
   Markup:  <tp-theme-toggle></tp-theme-toggle>  (rendert selbst Button + Icon) */

const SUN =
  '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.4 1.4M17.6 17.6 19 19M19 5l-1.4 1.4M6.4 17.6 5 19"></path></svg>';
const MOON =
  '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"></path></svg>';

class TpThemeToggle extends HTMLElement {
  connectedCallback() {
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.className = 'tp-theme-toggle__btn';
    this.button.setAttribute('aria-label', 'Hell-/Dunkelmodus umschalten');
    this.appendChild(this.button);
    this.paint();
    this.button.addEventListener('click', () => this.toggle());
  }

  current() {
    return document.documentElement.getAttribute('data-tptheme') === 'light' ? 'light' : 'dark';
  }

  paint() {
    // Icon zeigt das ZIEL (Sonne im Dark = "zu hell wechseln")
    this.button.innerHTML = this.current() === 'light' ? MOON : SUN;
    this.button.setAttribute('aria-pressed', this.current() === 'light' ? 'true' : 'false');
  }

  toggle() {
    const next = this.current() === 'light' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-tptheme', next);
    try {
      localStorage.setItem('tp-theme', next);
    } catch (e) {}
    // iOS/Android Statusbar-Farbe mitziehen (Funktion aus meta-tags.liquid)
    if (window.tpSyncThemeColor) window.tpSyncThemeColor();
    this.paint();
  }
}

if (!customElements.get('tp-theme-toggle')) {
  customElements.define('tp-theme-toggle', TpThemeToggle);
}
